module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-window', {
    attrs: {
      "vertical": ""
    },
    model: {
      value: (_vm.window),
      callback: function($$v) {
        _vm.window = $$v
      },
      expression: "window"
    }
  }, [_c('v-window-item', [_c('v-card', [_c('v-card-title', {
    staticClass: "subtitle-1 overline"
  }, [_vm._v("\n        Add a location\n        "), _c('v-spacer'), _vm._v(" "), (_vm.withClose) ? _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "The name of this location",
      "hint": "e.g.: Virgin Active Melrose, The Health Center Randburg, etc"
    },
    on: {
      "keypress": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.stopPropagation();
        return _vm.create.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.location.name),
      callback: function($$v) {
        _vm.$set(_vm.location, "name", $$v)
      },
      expression: "location.name"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.$emit("close")
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.req.loading,
      "disabled": _vm.location.name.length === 0,
      "color": "primary"
    },
    on: {
      "click": _vm.create
    }
  }, [_vm._v("Create")])], 1)], 1)], 1), _vm._v(" "), _c('v-window-item', [_c('location-edit', _vm._g({
    attrs: {
      "location": _vm.location
    },
    on: {
      "close": _vm.bubbleClose
    }
  }, _vm.$listeners))], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51a91314","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/settings/locations/LocationCreate.vue
// module id = 1424
// module chunks = 9